/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService
 */

export const fetchRpc = {
  serviceName: 'com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService',
  rpcName: 'fetch',
  auth: 'app',
  fingerprint: 'GrG7p29UZ9fpT9MDntRO4MYHw8MyCaa6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};